import React from "react";

export const PremiumColumnFormatter = (cellContent, row) => (
  <span className={`label label-lg label-light-${row.premium ? "info":"dark"} label-inline`} >
    {row.premium?"Pro":"Free"}
  </span>
);
